
<template>
    <loadingSpinner v-if="loading"  :loadingname=loadingname />
    <div v-if="!loading" class="bg-black space-y-4 px-8" style="padding-bottom: 14%; padding-top: 2%;">      
    <h2 class="text-xl text-white font-semibold" style="display: flex; justify-content: center;">Modify Request</h2>
    <fieldset class="fieldset">         
            <input v-model="data.job_id" maxlength="100" type="text" class="w-full px-4 py-2 bg-black text-white border border-white/30 rounded-md focus:outline-none focus:ring-2 focus:ring-white transition text-xl" placeholder="Job ID (Optional)" style="width: 100%; height: 3rem;" />
                        <span></span>

            <input v-model="data.job_url" type="text" class="w-full px-4 py-2 bg-black text-white border border-white/30 rounded-md focus:outline-none focus:ring-2 focus:ring-white transition text-xl" placeholder="Job Url (Mandatory)" style="width: 100%; height: 3rem;" />
                        <span></span>

            <input v-model="data.amount" min="100" type="number" class="w-full px-4 py-2 bg-black text-white border border-white/30 rounded-md focus:outline-none focus:ring-2 focus:ring-white transition text-xl" placeholder="Amount (Mandatory)" style="width: 100%; height: 3rem;" />
            <span></span>
                    <Multiselect
                v-model="data.company"
                :options="companies"
                placeholder="Select a company"
                track-by="name"
                label="name"
                :searchable="true"
                class="text-xl font-semibold"
              />
            <span></span>
            <textarea maxlength="500" v-model="data.about" type="text" class="w-full px-4 py-2 bg-black text-white border border-white/30 rounded-md focus:outline-none focus:ring-2 focus:ring-white transition text-xl" placeholder="About (Optional)" style="width: 100%; height: 12rem;" ></textarea>
            <span></span>
            <button ref="modifyBtn" name = "modify" @click="modify" class="rounded-md text-xl text-black font-semibold bg-white"  style="height: 2.75rem; width: 100%;" :disabled="!canEnable">
            <span v-if="modifying" class="loading loading-dots loading-xl"></span>
            <span v-if="!modifying">Modify</span>
            </button>          
          <span></span>
          <span></span>
        </fieldset>
    </div>
</template>

<script>
import { apiCall } from '@/js/main';
import loadingSpinner from './loading.vue';
import Multiselect from '@vueform/multiselect';
import '@vueform/multiselect/themes/default.css'

const initial = {
        company: "",
        job_url: "",
        job_id: "",
        about: "",
        amount: 100,
      }
export default {
  name: "modifyRequest",
  components:{
    loadingSpinner: loadingSpinner,
    Multiselect
  },
  props: {
    modifyId: {
      type: String, // or whatever type your ID is
      required: true
    }
  },
  data(){
    return {
      data: { ...initial },
      initialAmount: 0,
      loadingname: 'Loading',
      loading: true,
      companies: [],
      modifying: false
    }
  },
  methods:{
    async modify(){
      const input =  this.$refs.modifyBtn
      input.disabled = true
      this.modifying = true
      console.log(this.data.about)
      var data = await apiCall("/referral/"+this.modifyId, "PUT", this.data)
      if (data.success){
        const deltaAmount = this.initialAmount - this.data.amount
        this.$emit('closeModify',this.modifyId, deltaAmount, this.data);
        this.$emit('push-alert-modify', true, "Your request is modified")
      }
      else{
        this.$emit('push-alert-modify', false, data.error_message)
      }
      input.disabled = false
      this.modifying = false
    }
  },
  computed: {
        canEnable() {
            return this.data.company !== "" && this.data.amount >= 100 && this.data.job_url !== "";
        }
        },

  async beforeMount(){
    window.scrollTo({ top: 0, behavior: 'auto' })
    var data = await apiCall("/referral/"+ this.modifyId, "GET", null)
      if (data.success){
        this.data = data.data
        this.initialAmount = data.data.amount
      }
    var data = await apiCall("/user/company", "GET", null)

    if (data.success){
        this.companies = data.data
      }
    this.loading = false
  }
}
</script>
